import { render, staticRenderFns } from "./SegurExclusions.vue?vue&type=template&id=3205774d&scoped=true"
import script from "./SegurExclusions.vue?vue&type=script&lang=js"
export * from "./SegurExclusions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3205774d",
  null
  
)

export default component.exports